import { Meta } from "@solidjs/meta";
import Seo from "~/components/seo";
import LysztPage from "~/pages/lyszt";

export const route = { info: { flat: true } };

export default function Lyszt() {
  return (
    <main>
      <Meta name="robots" content="noindex" />
      <Seo
        title="João Luís - LinkTree | LYSZT"
        description="João Luís — LYSZT - LinkTree"
        path="/lyszt"
      />
      <LysztPage />
    </main>
  );
}
